import React, { memo } from 'react';
import cn from 'classnames';

import { ButtonV2 } from 'components/form';
import { useResponsive } from 'hooks/useResponsive';

import styles from './DeleteMember.module.scss';

export interface DeleteMemberProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  onSubmit: () => void;
  onCancel: () => void;
  selectedEmail?: string;
  isButtonLoading?: boolean;
}

export const DeleteMember: React.FC<DeleteMemberProps> = memo(
  ({
    className = '', // custom class name
    style, // custom style
    onSubmit,
    onCancel,
    selectedEmail,
    isButtonLoading = false,
  }: DeleteMemberProps) => {
    const contentClassNames = cn(
      {
        [styles.DeleteModal]: true,
      },
      className
    );
    const screens = useResponsive();

    return (
      <div
        className={contentClassNames}
        style={style}
        data-testid="DeleteMember"
      >
        <section className={styles.section}>
          <div className={styles.title}>Delete account</div>
          <p className={styles.desc}>
            Are you sure you want to delete{' '}
            <span className={styles.descEmail}>{selectedEmail}</span>?
          </p>
        </section>
        {screens.sm ? (
          <div className={cn(styles.done, styles.bgTransparent)}>
            <div className={cn(styles.deleteMember)}>
              <ButtonV2 onClick={onCancel} className={styles.cancel}>
                Cancel
              </ButtonV2>
              <ButtonV2
                isFullWidth={true}
                onClick={onSubmit}
                className={styles.deleteMemberButton}
                isLoading={isButtonLoading}
              >
                Yes, Delete
              </ButtonV2>
            </div>
          </div>
        ) : (
          <section className={styles.done}>
            <div className={cn(styles.button, styles.deleteMember)}>
              <ButtonV2 onClick={onCancel} className={styles.cancel} outlined>
                Cancel
              </ButtonV2>
              <ButtonV2
                onClick={onSubmit}
                className={styles.deleteMemberButton}
                isLoading={isButtonLoading}
              >
                Yes, Delete
              </ButtonV2>
            </div>
          </section>
        )}
      </div>
    );
  }
);

DeleteMember.displayName = 'DeleteMember';
